var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonIcon',_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.noninteractive.bottom",modifiers:{"hover":true,"noninteractive":true,"bottom":true}}],staticClass:"btn-reset-filters",attrs:{"icon":"filter","title":_vm.$t('restoreFiltersToTheDefaultSettings'),"variant":"light"}},'ButtonIcon',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }